export const initStickyContactBar = (): void => {
  const contactBar = document.querySelector<HTMLElement>(".sticky-contact-bar");

  if (!contactBar) return;

  let lastScrollY = window.scrollY;
  let scrollTimeout: number | undefined;

  let isPointerDown = false;
  let isScrolling = false;

  const evaluateTransparency = () => {
    if (!isPointerDown && !isScrolling) {
      contactBar.classList.remove("is-transparent");
    }
  };

  const handlePointerDown = () => {
    isPointerDown = true;
  };

  const handlePointerUp = () => {
    isPointerDown = false;
    evaluateTransparency();
  };

  window.addEventListener("mousedown", handlePointerDown);
  window.addEventListener("touchstart", handlePointerDown, { passive: true });

  window.addEventListener("mouseup", handlePointerUp);
  window.addEventListener("touchend", handlePointerUp, { passive: true });
  window.addEventListener("touchcancel", handlePointerUp, { passive: true });

  window.addEventListener(
    "scroll",
    () => {
      isScrolling = true;
      const currentScrollY = Math.max(0, window.scrollY);
      const deltaY = currentScrollY - lastScrollY;

      // Titreme (Jitter) eşiği 5'ten 10'a çıkarıldı (Hafif el titremelerinde bar gidip gelmesin diye)
      if (Math.abs(deltaY) < 10) return;

      // Aşağı kaydırma durumu
      if (deltaY > 0 && currentScrollY > 100) {
        contactBar.classList.add("is-transparent");
      }
      // Yukarı kaydırma durumu (Anında geri getir)
      else if (deltaY < 0) {
        contactBar.classList.remove("is-transparent");
      }

      lastScrollY = currentScrollY;

      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }

      // Stagger (Gecikme) süresi 250ms'den 800ms'ye çıkarıldı.
      // Kullanıcı kesik kesik okurken bar hemen belirmeyecek.
      scrollTimeout = window.setTimeout(() => {
        isScrolling = false;
        evaluateTransparency();
      }, 800);
    },
    { passive: true },
  );
};
